/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlContainFileAction = {
    Delete: 'delete',
    Quarantine: 'quarantine'
} as const;
export type ControlContainFileAction = typeof ControlContainFileAction[keyof typeof ControlContainFileAction];


export function ControlContainFileActionFromJSON(json: any): ControlContainFileAction {
    return ControlContainFileActionFromJSONTyped(json, false);
}

export function ControlContainFileActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlContainFileAction {
    return json as ControlContainFileAction;
}

export function ControlContainFileActionToJSON(value?: ControlContainFileAction | null): any {
    return value as any;
}

